import { Chart, ChartArea, ChartXAxis, ChartXAxisItem, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle, ChartTooltip, RenderEvent, SeriesVisualArgs } from "@progress/kendo-react-charts";
import { Switch } from "@progress/kendo-react-inputs";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import "hammerjs";
import { Fragment,useEffect,useState } from "react";
import { Circle as CircleGeometry } from '@progress/kendo-drawing/geometry';
import { Layout, Text } from '@progress/kendo-drawing';

export const OverViewPdf = (props: any) => {
    //To initialize values for line chart
    const [weekRange, setWeekRange] = useState<any>([]);
    const [lineChartCategories, setLineChartCategories] = useState<any>([]);

    //For category
    const [donutChartByCategories, setDonutChartByCategories] = useState<any>([]);

    //For sub-category
    const [donutChartBySubCategories, setDonutChartBySubCategories] = useState<any>([]);

    //For total minutes
    const [totalHours, setTotalHours] = useState<any>();

    //For total hours
    const [totalMinutes, setTotalMinutes] = useState<any>();

    //For total weeks
    const [totalNumberOfWeeks, setTotalNumberOfWeeks] = useState<any>();

    //For total sessions
    const [totalSessions, setTotalSessions] = useState<any>();

    useEffect(() => {
        setDonutChartByCategories(props.overViewDonutChartData.categories);
        setDonutChartBySubCategories(props.overViewDonutChartData.subCategories);
        setTotalHours(props.overViewDonutChartData.totalHours);
        setTotalMinutes(props.overViewDonutChartData.totalMinutes);
        setTotalNumberOfWeeks(props.overViewDonutChartData.totalNumberOfWeeks);
        setLineChartCategories(props.overViewDonutChartData.lineChartData);
        setWeekRange(props.overViewDonutChartData.weekRange);
    },[]);

    //To show the center of donut chart
    let center: any;
    let radius: any;

    //To create visuals for donut chart center
    const visualHandler = (e: SeriesVisualArgs) => {
        // Obtain parameters for the segments
        center = e.center;
        radius = e.innerRadius;

        // Create default visual
        return e.createVisual();
    };

    //To render the donut chart center
    const onRender = (e: RenderEvent) => {
        // The center and radius are populated by now.
        // We can ask a circle geometry to calculate the bounding rectangle for us.
        if (center) {
            const circleGeometry = new CircleGeometry([center.x, center.y], radius);
            const bbox = circleGeometry.bbox();

            // Render the text
            const heading = new Text(totalHours + 'h ' + totalMinutes + 'm', [0, 0], {
                font: "bold 20px Helvetica Now,Helvetica,Arial,'sans- serif'",
            });

            // Reflow the text in the bounding box
            const layout = new Layout(bbox, {
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                spacing: 5,
                orientation: 'vertical'
            });
            
            layout.append(heading);
            layout.reflow();

            // Draw it on the Chart drawing surface
            if (e.target.surface) {
                e.target.surface.draw(layout);
            }
        }
    };

    // To get color for line chart
    const getColorForLineChart = (item: any) => {
        let map = new Map<number, string>();
        map.set(1, '#0967B1');
        map.set(2, '#DA1F6C');
        map.set(3, '#008E82');
        map.set(4, '#6F4F9B');
        map.set(5, '#EA580D');
        map.set(-888, 'grey');
        map.set(-999, '#FFDF00');

        if (item.isUserDefined) {
            return '#76A227'
        } else {
            return map.get(item.categoryId);
        }
    }

    //To map the catgories for line chart
    const mapSeries = (item: any, index : any) => {
        return (
            <ChartSeriesItem key={index} data={item.totalWorkedHours} type="scatterLine"
                color={getColorForLineChart(item)}
                width={(item.categoryId === -999) || (item.categoryId === -888) ? 2 : 1}
                dashType={(item.categoryId === 1 || item.categoryId === 4 || item.isUserDefined) ? 'dash' : 'solid'}
                markers={{
                    size: ((item.categoryId === 1 || item.categoryId === -999 || item.categoryId === -888) ? 24 :
                        (item.categoryId === 2 || item.categoryId === 4) ? 15 :
                            (item.categoryId === 5 || item.isUserDefined) ? 9 :
                                (item.categoryId === 3) ? 30 : 24),
                    type: ((item.categoryId === 1 || item.categoryId === -999 || item.categoryId === -888) ? 'circle' :
                        (item.categoryId === 2 || item.categoryId === 4) ? 'square' :
                            (item.categoryId === 5 || item.isUserDefined) ? 'triangle' :
                                (item.categoryId === 3) ? 'cross' : 'circle'),
                    visible: totalNumberOfWeeks == 1 ? true : (item.categoryId === -888) ? false : true,
                    background : "none"
                }}
            />
        );
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-5 mb-2 p-0">
                        <div className="mb-0">
                            {props.overViewDonutChartData.isPublicHolidayToggelChecked && <Switch size="small" defaultChecked={true} onLabel={""} offLabel={""} />}
                            {!props.overViewDonutChartData.isPublicHolidayToggelChecked && <Switch size="small" defaultChecked={false} onLabel={""} offLabel={""} />}
                            <label className="form-check-label fs-5 ms-2">Exclude weeks with public holidays</label>
                        </div>
                        <div className="mb-0">
                            {props.overViewDonutChartData.isLeaveToggelChecked && <Switch size="small" defaultChecked={true} onLabel={""} offLabel={""} />}
                            {!props.overViewDonutChartData.isLeaveToggelChecked && <Switch size="small" defaultChecked={false} onLabel={""} offLabel={""} />}
                            <label className="form-check-label fs-5 ms-2">Exclude weeks with leave</label>
                        </div>
                        <span className="text-muted fs-5 mt-3 mb-0">Weeks showing : {totalNumberOfWeeks}</span>
                        {totalSessions == 0 && (<p>No activities in diary for this week.</p>)}
                    </div>
                </div>
            </div>

            <div className="Container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <Chart transitions={false}>
                            <ChartTitle text="Total hours worked" position="top" align="left" />
                            <ChartXAxis>
                                <ChartXAxisItem
                                    title={{ text: "Weeks", position: "bottom" }}
                                    categories={weekRange}
                                    max={(totalNumberOfWeeks >= 8) ? (weekRange[weekRange.length - 1] + 0.5) : weekRange[weekRange.length - 1]}
                                />
                            </ChartXAxis>
                            <ChartSeries>
                                {
                                    lineChartCategories.map(mapSeries)
                                }
                            </ChartSeries>
                        </Chart>
                    </div>
                </div>
            </div>
            <div className="Container-fluid">
                <div className="row">
                    <div className="col-lg-6">
                        <Chart transitions={false} onRender={onRender}>
                            <ChartTooltip background="#fff" />
                            <ChartLegend visible={false} />
                            <ChartArea background="none" />
                            <ChartSeries>
                                <ChartSeriesItem visual={visualHandler}
                                    name="subCategories"
                                    width={500}
                                    type="donut"
                                    startAngle={0}
                                    field="totalDurationMinutes"
                                    categoryField="name"
                                    data={donutChartBySubCategories}
                                    colorField="color"
                                    size={40}
                                    holeSize={50}
                                    margin={3} >
                                </ChartSeriesItem>
                                <ChartSeriesItem visual={visualHandler}
                                    name="categories"
                                    width={500}
                                    type="donut"
                                    startAngle={0}
                                    field="totalDurationMinutes"
                                    categoryField="name"
                                    data={donutChartByCategories}
                                    colorField="color"
                                    size={60}
                                    holeSize={50}
                                    margin={3} >
                                </ChartSeriesItem>
                            </ChartSeries>
                        </Chart>
                    </div>
                    <div className="col-lg-2">
                    </div>
                    <div className="col-lg-4 mt-5">
                        {donutChartByCategories && donutChartByCategories.map((category: any, index: any) => (
                            <Fragment key={index}>
                                <ExpansionPanel
                                    expandIcon="k-icon k-i-arrow-60-right"
                                    collapseIcon="k-icon k-i-arrow-60-down"
                                    style={{ border: 'none', borderBottom: "2px solid lightgrey" }}
                                    expanded={true}
                                    tabIndex={0}
                                    key={category.id}
                                    title={
                                        <div className="row mt-2">
                                            <span className="mr-2">
                                                <svg width="50" height="50">
                                                    <circle cx="25" cy="25" r="25" fill={category.color} fillOpacity="0.3" />
                                                    <circle cx="25" cy="25" r="15" fill={category.color} fillOpacity="0.7" />
                                                    <circle cx="25" cy="25" r="5" fill={category.color} fillOpacity="1" />
                                                </svg>
                                                <label className="text-dark ps-2"><b>{category.name} - {category.totalHours?.toFixed(0)}h {category.totalMinutes?.toFixed(0)}m</b></label>
                                            </span>
                                        </div>
                                    }
                                />
                                {donutChartBySubCategories.filter((x: any) => x.categoryId == category.id).map((subCategory: any, index: any) => (
                                    <Fragment key={index}>
                                        {true && (
                                            <div className="container-fluid">
                                                <ExpansionPanelContent >
                                                    <div className="row mt-2">
                                                        <span className="col-1 ps-4 ms-1">
                                                            <svg width="20" height="20">
                                                                <circle cx="10" cy="10" r="10" fill={subCategory.color} />
                                                            </svg>
                                                        </span>
                                                        <label className="col-6 ps-4 ms-1">{subCategory.name}</label>
                                                        <label className="col-4 ps-3">{subCategory.totalHours?.toFixed(0)}h {subCategory.totalMinutes?.toFixed(0)}m</label>
                                                    </div>
                                                </ExpansionPanelContent>
                                            </div>
                                        )}
                                    </Fragment>
                                ))}
                            </Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}